import React from 'react';
import { CopyIcon, ImageIcon } from 'lucide-react';
import { toast } from 'sonner';
import { PageHeader } from '../components/common/PageHeader';
const agencies = [{
  name: '指南者留学',
  strong: '英港新名校',
  service: '三对一',
  price: '4-8 万',
  match: 92
}, {
  name: 'A 留学',
  strong: '美研 CS / 商科',
  service: '一对一',
  price: '6-12 万',
  match: 78
}, {
  name: 'B 国际',
  strong: '英联邦',
  service: '半 DIY',
  price: '2-5 万',
  match: 70
}, {
  name: 'C 顾问',
  strong: '艺术留学',
  service: '导师制',
  price: '8-15 万',
  match: 65
}];
const tips = [{
  t: '签约前确认导师资历',
  d: '要求查看主导师的过往案例与院校背景，避免被销售导师调包。'
}, {
  t: '看清退款条款',
  d: '关注"申请失败"的定义、退款比例与时间节点，以书面形式确认。'
}, {
  t: '服务节点责任人',
  d: '确认每个阶段（咨询/规划/文书/网申/签证）的具体负责人与交付时间。'
}];
const scripts = ['请问主导师是谁？我可以查看 ta 过往的案例库吗？', '如果申请失败，退款比例与流程是怎样的？是否有书面条款？', '文书是定制还是模板？是否提供修改轮次的明确次数？'];
export function AgencyAnalysis() {
  const copy = (txt: string) => {
    navigator.clipboard?.writeText(txt);
    toast.success('已复制到剪贴板');
  };
  return <div className="bg-slate-50 min-h-screen pb-20" data-id="element-174">
      <PageHeader title="机构分析工具" data-id="element-175" />

      {/* 适配度 */}
      <div className="m-3 bg-white rounded-2xl p-4" data-id="element-176">
        <div className="font-bold text-slate-800 mb-3 flex items-center gap-2" data-id="element-177">
          <span className="w-1 h-4 bg-blue-500 rounded" data-id="element-178" /> 机构适配度分析
        </div>
        <div className="overflow-x-auto -mx-4 px-4" data-id="element-179">
          <table className="w-full text-xs" data-id="element-180">
            <thead data-id="element-181">
              <tr className="text-slate-500" data-id="element-182">
                <th className="text-left py-2 font-medium" data-id="element-183">机构</th>
                <th className="text-left py-2 font-medium" data-id="element-184">擅长</th>
                <th className="text-left py-2 font-medium" data-id="element-185">服务</th>
                <th className="text-left py-2 font-medium" data-id="element-186">收费</th>
                <th className="text-right py-2 font-medium" data-id="element-187">适配度</th>
              </tr>
            </thead>
            <tbody data-id="element-188">
              {agencies.map(a => <tr key={a.name} className="border-t border-slate-100" data-id="element-189">
                  <td className="py-2.5 text-slate-800 font-semibold" data-id="element-190">
                    {a.name}
                  </td>
                  <td className="py-2.5 text-slate-600" data-id="element-191">{a.strong}</td>
                  <td className="py-2.5 text-slate-600" data-id="element-192">{a.service}</td>
                  <td className="py-2.5 text-slate-600" data-id="element-193">{a.price}</td>
                  <td className="py-2.5" data-id="element-194">
                    <div className="flex items-center justify-end gap-1.5" data-id="element-195">
                      <div className="w-16 h-1.5 bg-slate-100 rounded-full overflow-hidden" data-id="element-196">
                        <div className="h-full bg-blue-600" style={{
                      width: `${a.match}%`
                    }} data-id="element-197" />
                      </div>
                      <span className="text-blue-600 font-bold" data-id="element-198">
                        {a.match}%
                      </span>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* 避坑清单 */}
      <div className="m-3 bg-white rounded-2xl p-4" data-id="element-199">
        <div className="font-bold text-slate-800 mb-3 flex items-center justify-between" data-id="element-200">
          <span className="flex items-center gap-2" data-id="element-201">
            <span className="w-1 h-4 bg-rose-500 rounded" data-id="element-202" /> 签约避坑清单
          </span>
          <button onClick={() => toast.success('已保存图片到相册')} className="text-xs text-blue-600 flex items-center gap-1" data-id="element-203">
            <ImageIcon size={12} data-id="element-204" /> 保存图片
          </button>
        </div>
        <div className="space-y-2" data-id="element-205">
          {tips.map(tp => <div key={tp.t} className="bg-rose-50 rounded-xl p-3" data-id="element-206">
              <div className="text-sm font-bold text-rose-700" data-id="element-207">⚠ {tp.t}</div>
              <div className="text-xs text-slate-600 mt-1 leading-relaxed" data-id="element-208">
                {tp.d}
              </div>
            </div>)}
        </div>
      </div>

      {/* 沟通话术 */}
      <div className="m-3 bg-white rounded-2xl p-4" data-id="element-209">
        <div className="font-bold text-slate-800 mb-3 flex items-center gap-2" data-id="element-210">
          <span className="w-1 h-4 bg-blue-500 rounded" data-id="element-211" /> 沟通话术模板
        </div>
        <div className="space-y-2" data-id="element-212">
          {scripts.map(s => <div key={s} className="bg-blue-50 rounded-xl p-3 flex items-start gap-2" data-id="element-213">
              <div className="flex-1 text-sm text-slate-700 leading-relaxed" data-id="element-214">
                "{s}"
              </div>
              <button onClick={() => copy(s)} className="text-blue-600 text-xs flex items-center gap-1 shrink-0" aria-label="复制" data-id="element-215">
                <CopyIcon size={12} data-id="element-216" /> 复制
              </button>
            </div>)}
        </div>
      </div>
    </div>;
}